import { Brick, registerBrick } from 'olympe';
import {parse} from 'date-fns';

export default class ParseDateToDateTime extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} date
     * @param {string} format
     * @param {function(*)} setDateTime
     */
    update($, [date, format], [setDateTime]) {
        let result = date;
        // eslint-disable-next-line
        const formatString = format || "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
        if (typeof date === 'string') {
            result = parse(date, formatString, new Date())
        }
        setDateTime(result);
    }
}

registerBrick('018a18e23a947229d8b0', ParseDateToDateTime);
